import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const addRemovePermission = (id, role, checked) => {
  let permissions = ["read", "write", "execute", "delete"];
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_REMOVE_PERMISSION_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/acl/add-remove-permission`,
        { id, role, checked, permissions },
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_REMOVE_PERMISSION_SUCCESS", payload: data });
      } else {
        dispatch({ type: "ADD_REMOVE_PERMISSION_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "ADD_REMOVE_PERMISSION_FAIL", payload: error?.response?.data?.message });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const fetchPermission = () => {
  let page = 1;
  let limit = 100;
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "FETCH_PERMISSION_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/acl/list`,
        { page, limit },
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "FETCH_PERMISSION_SUCCESS", payload: data });
      } else {
        dispatch({ type: "FETCH_PERMISSION_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "FETCH_PERMISSION_FAIL", payload: error?.response?.data?.message });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const updateAcl = (id, image) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_ACL_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.put(
        `${BASE_URL}/acl/update`,
        { id, image },
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_ACL_SUCCESS", payload: data });
      } else {
        dispatch({ type: "UPDATE_ACL_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "UPDATE_ACL_FAIL", payload: error?.response?.data?.message });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const removeAcl = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "REMOVE_ACL_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.delete(
        `${BASE_URL}/acl/remove/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "REMOVE_ACL_SUCCESS", payload: data });
      } else {
        dispatch({ type: "REMOVE_ACL_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "REMOVE_ACL_FAIL", payload: error?.response?.data?.message });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
